import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { CompaniesResolver } from './_resolvers/companies.resolver';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'extrato-de-pagamento',
    canActivate: [AuthGuard],
    resolve: {
      companies: CompaniesResolver
    },
    loadChildren: () => import('./payment-statements/payment-statements.module').then(m => m.PaymentStatementsModule),
  },
  {
    path: 'rendimentos',
    canActivate: [AuthGuard],
    resolve: {
      companies: CompaniesResolver
    },
    loadChildren: () => import('./income-report/income-report.module').then(m => m.IncomeReportModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
